import React, { useState, useContext } from 'react';
import AuthContext from '../context/AuthContext';
import { NavLink } from 'react-router-dom';
import { FaAngleDown, FaAngleUp } from 'react-icons/fa'; // Import ikon
import './Sidebar.css';
import logo from '../assets/images/logo.png';

const Sidebar = ({ isSidebarOpen }) => {
  const [isManageServicesOpen, setManageServicesOpen] = useState(false);
  const { user } = useContext(AuthContext);

  if (!user) {
    return null;
  }

  const isActiveLink = (path) => window.location.pathname === path;
  const isManageServicesActive = isActiveLink('/jadwal-servis') || isActiveLink('/riwayat-servis');

  return (
    <aside className={`sidebar ${isSidebarOpen ? 'active' : ''}`}>
      <div className="sidebar-header">
        <img src={logo} alt="Logo Perusahaan" className="sidebar-logo-img" />
        <h1 className="sidebar-logo-text">Ms. Kendis SKP</h1>
      </div>
      <nav className="sidebar-nav">
        <ul>
          <li className="nav-item">
            <NavLink to="/" className={({ isActive }) => (isActive ? 'active' : '')}>
              Dashboard
            </NavLink>
          </li>
          {(user.role === 'superadmin' || user.role === 'operator') && (
            <>
              <li className="nav-item">
                <NavLink to="/kendaraan" className={({ isActive }) => (isActive ? 'active' : '')}>
                  Kendaraan
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink to="/pengguna-kendaraan" className={({ isActive }) => (isActive ? 'active' : '')}>
                  Pengguna Kendaraan
                </NavLink>
              </li>
            </>
          )}

          <li className="nav-item-has-submenu">
            <div
              className={`nav-item-header ${isManageServicesActive ? 'active' : ''}`}
              onClick={() => setManageServicesOpen(!isManageServicesOpen)}
            >
              <span>Kelola Servis</span>
              {isManageServicesOpen ? <FaAngleUp /> : <FaAngleDown />}
            </div>
            <ul className={`submenu ${isManageServicesOpen || isManageServicesActive ? 'open' : ''}`}>
              <li>
                <NavLink to="/jadwal-servis" className={({ isActive }) => (isActive ? 'active' : '')}>
                  Jadwal Servis
                </NavLink>
              </li>
              {(user.role === 'superadmin' || user.role === 'operator') && (
                <>
                  <li>
                    <NavLink to="/riwayat-servis" className={({ isActive }) => (isActive ? 'active' : '')}>
                      Riwayat Servis
                    </NavLink>
                  </li>
                  <li>
                    <NavLink to="/service-responses" className={({ isActive }) => (isActive ? 'active' : '')}>
                      Respon Servis
                    </NavLink>
                  </li>
                </>
              )}
            </ul>
          </li>

          {(user.role === 'superadmin' || user.role === 'operator') && (
            <>
              <li className="nav-item">
                <NavLink to="/laporan" className={({ isActive }) => (isActive ? 'active' : '')}>
                  Laporan
                </NavLink>
              </li>
            </>
          )}
          
          <li className="nav-item">
            <NavLink to="/e-book" className={({ isActive }) => (isActive ? 'active' : '')}>
              E-Book
            </NavLink>
          </li>
        </ul>
      </nav>
    </aside>
  );
};

export default Sidebar;